import { DateRangePicker, Icon, InputGroup } from "rsuite";
import { ValueType } from "rsuite/lib/DateRangePicker";
import { useDataset } from "../DataSet/DatasetProvider";
import { StandardFilterProps } from "../types";

interface IDynamicDateRangePickerProps extends StandardFilterProps {}

const DynamicDateRangePicker = (props: IDynamicDateRangePickerProps) => {
  const { getFilterValue, setFilterValue } = useDataset();

  const rawValue = getFilterValue(props.filterDef.code) as ValueType;

  const value: ValueType = Array.isArray(rawValue) ? rawValue : [];

  const hasValue = value.length === 2 && (value[0] || value[1]);
  const className = hasValue ? "filled" : "";

  const handleClear = () => {
    setFilterValue(props.filterDef.code, []);
  };

  return (
    <InputGroup inside>
      <DateRangePicker
        placement="auto"
        preventOverflow
        placeholder={props.placeholder}
        value={value}
        onChange={(v) => setFilterValue(props.filterDef.code, v ?? [])}
        className={className}
        block
        cleanable
      />

      {hasValue && (
        <InputGroup.Addon onClick={handleClear} style={{ cursor: "pointer" }}>
          <Icon icon="close" />
        </InputGroup.Addon>
      )}
    </InputGroup>
  );
};

export default DynamicDateRangePicker;
